import axios from './financeiroApi';

const centroCustoApi = () => {
  const getPathCentroCusto = () => {
    return `/api/v1/backend/centro-custo`;
  };

  const getPathCentroCustoGrupo = () => {
    return `/api/v1/backend/centro-custo-grupo`;
  };

  return {
    buscarTodos: async () => {
      const url = `${getPathCentroCusto()}`;
      return axios.get(url);
    },
    buscarGrupoPorCategoria: async (categoriaId) => {
      const url = `${getPathCentroCustoGrupo()}`;
      return axios.get(`${url}/buscarGrupoPorCategoria/${categoriaId}`);
    },
    removerCentroCusto: async (centroCustoId) => {
      const url = `${getPathCentroCusto()}`;
      return axios.delete(`${url}/${centroCustoId}`);
    },
    removerCentroCustoClasse: async (classeId) => {
      const url = `${getPathCentroCusto()}`;
      return axios.delete(`${url}/${classeId}/centroCustoClasse`);
    },
    cadastrar: async (classe) => {
      const url = `${getPathCentroCusto()}/criarClasse`;
      return axios.post(url, classe);
    },
    editar: async (classe) => {
      const url = `${getPathCentroCusto()}/editarClasse`;
      return axios.put(url, classe);
    },
    criarCentroCustoGrupo: async (grupo) => {
      const url = `${getPathCentroCustoGrupo()}`;
      return axios.post(url, grupo);
    },
    editarGrupo: async (grupo) => {
      const url = `${getPathCentroCustoGrupo()}/editarGrupo`;
      return axios.put(url, grupo);
    },
    removerCentroCustoGrupo: async (grupoId) => {
      const url = `${getPathCentroCustoGrupo()}`;
      return axios.delete(`${url}/${grupoId}/centroCustoGrupo`);
    },
    buscarClasse: async (params) => {
      const url = `${getPathCentroCusto()}/buscarClasses`;
      return axios.get(url, { params });
    },
    buscarGrupo: async (params) => {
      const url = `${getPathCentroCustoGrupo()}/buscarGrupos`;
      return axios.get(url, { params });
    },
  };
};
export { centroCustoApi };
